import { useRouter } from 'next/router';
import * as React from 'react'
import { useLnRouterUser } from '../useLnRouterUser';
import { UserPlanType, useUserPlan } from './useUserPlan';





type Props = {
  mustBe?: UserPlanType,
  elseElement?: React.ReactElement,
  loadingElement?: React.ReactElement,
  children: any,
  redirectUrl?: string
}


const UserPlanGuard: React.FC<Props> = ({ mustBe = undefined, children, elseElement = <React.Fragment />, loadingElement = <React.Fragment />,
  redirectUrl = undefined }: Props) => {
  // const user = useLnRouterUser();
  const userPlan = useUserPlan();


  const router = useRouter();

  React.useEffect(() => {
    if (redirectUrl === undefined) {
      return;
    }
    // console.log('plan', userPlan);
    if (!userPlan.plan) {
      return;
    }
    if (userPlan.plan !== 'SUBSCRIBED') {
      // console.log('redirect', userPlan.plan);
      router.push({
        pathname: '/channel-recommender-preview'
      })
    }
  }, [userPlan])

  // console.warn('userPlanGuard', userPlan);

  if (userPlan.loading) {
    return loadingElement;
  }

  if (mustBe === undefined) {
    return children;
  }
  if (userPlan.plan === mustBe) {
    return children;
  }

  return elseElement;
}

export default UserPlanGuard;

